import { Button } from '@heroui/react';
import { manrope } from '@trwl/app/fonts';
import cn from 'classnames';

interface Props {
  onIncrement: () => void;
  onDecrement: () => void;
  count: number;
}

export const Counter = (props: Props) => {
  return (
    <div className={'flex flex-row items-center'}>
      <Button
        disableRipple
        size={'sm'}
        radius={'none'}
        className={cn(
          'bg-[#F3F3F3] rounded-[2px] !p-0 min-w-[24px] w-[24px] h-[24px] text-[#282828] text-[20px]',
          manrope.className,
        )}
        onPress={props.onDecrement}
      >
        <span className={'pb-[3px]'}>-</span>
      </Button>
      <div className={'w-[24px] text-center pt-0.5 font-medium text-[14px]'}>
        {props.count}
      </div>
      <Button
        disableRipple
        size={'sm'}
        radius={'none'}
        className={cn(
          'bg-[#F3F3F3] rounded-[2px] !p-0 min-w-[24px] w-[24px] h-[24px] text-[#282828] text-[20px]',
          manrope.className,
        )}
        onPress={props.onIncrement}
      >
        <span className={'pb-[1px]'}>+</span>
      </Button>
    </div>
  );
};
